<template>
  <div class="mzjf-list" @click="clickEvn(item)">
    <div class="list-item">
      <span class="item-value">就诊科室：</span>
      <span class="item-title">{{ item.deptName }}</span>
    </div>
    <div class="list-item">
      <span class="item-value">开单医生：</span>
      <span class="item-title">{{ item.doctorName }}</span>
    </div>
    <!--    <div class="list-item">
      <span class="item-value" style="width: 84px">待缴费项目：</span>
      <span class="item-title">{{ item.chargeName }}</span>
    </div>-->
    <div class="list-item">
      <!--      <span class="item-title">缴费时间：</span>-->
      <span class="item-value">{{ item.chargeList[0].createTime }}</span>
      <span class="item-status">待缴费：{{ item.amount }}元</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenZhenJiaoFeiListItem',
  filters: {
    status: (val) => {
      switch (val) {
        case '0':
          return '待缴费'
        case '1':
          return '缴费成功'
        case '2':
          return '已作废'
        default:
          return ''
      }
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {}
  },
  created() {},
  mounted() {
  },
  methods: {
    clickEvn(obj) {
      localStorage.setItem('jfmx', JSON.stringify(obj.chargeList))
      this.$router.push(`/jiaofeimingxi?amount=${obj.amount}`)
    }
  }
}
</script>
<style lang="less" scoped>
.mzjf-list {
  .list-item {
    display: flex;
    .item-title{
      flex: 1;
    }
    .item-status {
      color: #2B8CFF;
      flex: 1;
      text-align: right;
    }
  }
}
</style>
